import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
export var ScriptLoader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ScriptLoader, _React$Component);

  function ScriptLoader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ScriptLoader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        children = _this$props.children,
        initScript = _this$props.initScript,
        onLoad = _this$props.onLoad;
    var id = "id-" + children.props.src;

    if (document.getElementById(id)) {
      if (initScript) initScript();
      if (onLoad) onLoad();
      return;
    }

    var bodyElement = document.getElementsByTagName('body')[0];
    var scriptElement = document.createElement('script');
    Object.keys(children.props).forEach(function (key) {
      return scriptElement.setAttribute(key, children.props[key]);
    });
    scriptElement.id = id; // if ( window ) {
    //   window.onload = ()=> bodyElement.append( scriptElement )
    // }

    bodyElement.append(scriptElement);

    scriptElement.onload = function () {
      return onLoad && onLoad();
    };
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };

  return ScriptLoader;
}(React.Component);